import React, { Component } from "react";
import "../../style/common/leftBar.scss";
import logo from "../../image/logo.png";
import StroyIcon from "../../icon/StoryIcon";
import CommentIcon from "../../icon/CommentIcon";
import OrderIcon from "../../icon/OrderIcon";
import CategoryIcon from "../../icon/CategoryIcon";

class LeftBar extends Component {
  constructor(props) {
    super(props);
    this.routePage = this.routePage.bind(this);
  }

  routePage(type) {
    const { history } = this.props;
    switch (type) {
      case "story":
        history.push("/Story");
        break;
      case "comment":
        history.push("/Comment");
        break;
      case "category":
        history.push("/Category");
        break;
      default:
        break;
    }
  }

  render() {
    let { location } = this.props;
    return (
      <React.Fragment>
        <div className="leftBar">
          <div className="left-box">
            <div className="head-title">
              <img src={logo} alt="" />
              <p>Management</p>
            </div>
            <ul className="tab-list">
              <li
                className={location.pathname === "/Category" ? "active" : ""}
                onClick={() => this.routePage("category")}
              >
                {location.pathname === "/Category" ? (
                  <CategoryIcon size={20} className="icon" color="#696cff" />
                ) : (
                  <CategoryIcon size={20} className="icon" color="#697A8D" />
                )}
                <p>Category</p>
              </li>
              <li
                className={
                  location.pathname === "/Story" ||
                  location.pathname === "/AddStory"
                    ? "active"
                    : ""
                }
                onClick={() => this.routePage("story")}
              >
                {location.pathname === "/Story" ||
                location.pathname === "/AddStory" ? (
                  <StroyIcon size={25} className="icon" color="#696cff" />
                ) : (
                  <StroyIcon size={25} className="icon" color="#697A8D" />
                )}
                <p>Story</p>
              </li>
              {/* <li
                className={location.pathname === "/Comment" ? "active" : ""}
                onClick={() => this.routePage("comment")}
              >
                {location.pathname === "/Comment" ? (
                  <CommentIcon size={25} className="icon" color="#696cff" />
                ) : (
                  <CommentIcon size={25} className="icon" color="#697A8D" />
                )}
                <p>Comment</p>
              </li> */}
            </ul>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default LeftBar;
